import { render, staticRenderFns } from "./RoundResults.vue?vue&type=template&id=a27e3eee&scoped=true"
import script from "./RoundResults.vue?vue&type=script&lang=js"
export * from "./RoundResults.vue?vue&type=script&lang=js"
import style0 from "./RoundResults.vue?vue&type=style&index=0&id=a27e3eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e3eee",
  null
  
)

export default component.exports